<template>
  <div class="row">
    <div class="mb-5 col-4">
      <label>
        {{$t('CONTENT.assets.leased_amount')}}:
        <span class="b-form__required">*</span>
      </label>
      <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="newQuantity"></numeric>
    </div>
  </div>
</template>

<script>
import ChangeQuantity from "../../models/commands/ChangeQuantity";
import dateConverter from "../../../../utils/converters/date.converter";
export default {
  props: {
    assetComponent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newQuantity: true
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.newQuantity = this.assetComponent.quantity;
    },

    cancel() {
      this.init();
    },

    save() {
      const command = new ChangeQuantity(
        this.assetComponent.idInDB,
        this.newQuantity
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
